import { Rule } from 'antd/es/form';
import { TFunction } from 'i18next';

import { CustomerDataFormFieldsMaxLength } from './customerDataConstants';
import {
  addressWarningValidator,
  nameWarningValidator,
  phoneValidator,
} from './customerDataFormUtils';

export const getFormRules = (t: TFunction): { [key: string]: Rule[] } => ({
  customerName: [
    { whitespace: true },
    {
      required: true,
      message: t('SAVE.MESSAGES.NAME'),
    },
    {
      max: CustomerDataFormFieldsMaxLength.CUSTOMER,
      message: `Must be less than ${CustomerDataFormFieldsMaxLength.CUSTOMER} characters`,
    },
    {
      warningOnly: true,
      validator: nameWarningValidator,
      message: '',
    },
  ],
  address1: [
    { whitespace: true },
    { required: true, message: t('SAVE.MESSAGES.ADDRESS') },
    {
      max: CustomerDataFormFieldsMaxLength.ADDRESS,
      message: `Must be less than ${CustomerDataFormFieldsMaxLength.ADDRESS} characters`,
    },
    {
      warningOnly: true,
      validator: addressWarningValidator,
      message: '',
    },
  ],
  address2: [
    { whitespace: true },
    {
      max: CustomerDataFormFieldsMaxLength.ADDRESS,
      message: `Must be less than ${CustomerDataFormFieldsMaxLength.ADDRESS} characters`,
    },
  ],
  city: [
    { whitespace: true },
    { required: true, message: t('SAVE.MESSAGES.CITY') },
    {
      max: CustomerDataFormFieldsMaxLength.CITY,
      message: `Must be less than ${CustomerDataFormFieldsMaxLength.CITY} characters`,
    },
  ],
  state: [
    { whitespace: true },
    {
      pattern: /^[a-zA-Z]{2}$/,
      message: 'Invalid state',
    },
    { len: 2 },
    { required: true, message: t('SAVE.MESSAGES.STATE') },
  ],
  zip: [
    { whitespace: true },
    { required: true, message: t('SAVE.MESSAGES.ZIP') },
    {
      pattern: /^[0-9]{5}(?:-[0-9]{4})?$/,
      message: 'Invalid zip code',
    },
  ],
  phone: [
    { whitespace: true },
    {
      max: CustomerDataFormFieldsMaxLength.PHONE,
      message: `Must be less than ${CustomerDataFormFieldsMaxLength.PHONE} characters`,
    },
    {
      message: t('SAVE.MESSAGES.INVALID_PHONE'),
      validator: phoneValidator,
    },
  ],
  phoneRequired: [
    {
      required: true,
      message: t('SAVE.MESSAGES.PHONE'),
    },
  ],
  alternatePhone: [
    { whitespace: true },
    {
      message: t('SAVE.MESSAGES.INVALID_PHONE'),
      validator: phoneValidator,
    },
    {
      max: CustomerDataFormFieldsMaxLength.PHONE,
      message: `Must be less than ${CustomerDataFormFieldsMaxLength.PHONE} characters`,
    },
  ],
  email: [
    {
      type: 'email',
      required: true,
      message: t('SAVE.MESSAGES.EMAIL'),
    },
  ],
});
